import { getMessaging, getToken, deleteToken, isSupported } from "firebase/messaging";
import { deleteDoc, doc, serverTimestamp, setDoc } from "firebase/firestore";
import { app, auth, db } from "./firebase";

// Clave pública "Web Push certificate" de Firebase Cloud Messaging (Configuración del proyecto → Cloud Messaging)
const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;
const SERVICE_WORKER_URL = `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`;

// Un solo service worker para instalar la app y para el push (registrar dos en "/" haría que uno pise al otro)
export const registerServiceWorker = () => {
  if (!("serviceWorker" in navigator)) return Promise.resolve(null);
  return navigator.serviceWorker.register(SERVICE_WORKER_URL);
};

export const isPushAvailable = async () => {
  if (!VAPID_KEY || !("serviceWorker" in navigator) || !("Notification" in window)) return false;
  try {
    return await isSupported();
  } catch {
    return false;
  }
};

const getDeviceToken = async () => {
  const registration = await registerServiceWorker();
  return getToken(getMessaging(app), { vapidKey: VAPID_KEY, serviceWorkerRegistration: registration });
};

// Registra este dispositivo para recibir push del usuario (requiere permiso de notificaciones concedido)
export const registerPushToken = async (uid) => {
  if (!uid || Notification.permission !== "granted" || !(await isPushAvailable())) return null;
  const token = await getDeviceToken();
  if (!token) return null;
  await setDoc(doc(db, "users", uid, "fcmTokens", token), {
    createdAt: serverTimestamp(),
    userAgent: navigator.userAgent.slice(0, 200),
  });
  return token;
};

// Deja de enviar push a este dispositivo (se llama antes de cerrar sesión)
export const unregisterPushToken = async () => {
  const user = auth.currentUser;
  if (!user || Notification.permission !== "granted" || !(await isPushAvailable())) return;
  try {
    const token = await getDeviceToken();
    if (token) await deleteDoc(doc(db, "users", user.uid, "fcmTokens", token));
    await deleteToken(getMessaging(app));
  } catch {
    // Si falla, la Cloud Function borra el token cuando FCM lo rechace
  }
};
